<template>
    <div>
        <div class="nav">
            <v-head></v-head>
        </div>
        <v-route :bindData="bindData"></v-route>
        <div class="container" style="text-align: center;height: 700px;">
            <v-breadcrumb value1="首页" value2="廉江特色" value3="美丽乡村" :url="url"></v-breadcrumb>

            <!-- <swiper :options="swiperOption" style="margin-top: 50px" v-if="dataList.length>0">

                　　<swiper-slide  v-for="(v,key) in dataList" :key="key">
                <img   @click="toDetail(v.path)" :src="v.coverImageUrl" class="move hover">
                <div @click="toDetail(v.path)" class="swiper_title " >{{v.title}}</div>
            </swiper-slide>

                <div class="swiper-button-prev" slot="button-prev" ></div>
                <div class="swiper-button-next" slot="button-next" ></div>

            </swiper>
            <div class="w1200" style="height: 20px;margin-top: 20px">
                <div class="swiper-pagination" ></div>
            </div> -->


            <el-carousel trigger="click" class="carousel" :interval="1000000" height="600px">
				<el-carousel-item v-for="(v, key) in dataList" :key="key" class="carousel-item">
					<div @click="toDetail(v.path)" class="carousel-item-i" :style="{ background: 'url(' + v.coverImageUrl + ') center/cover no-repeat' }">
						<div class="carousel-item-i-title ">{{ v.title }}</div>
					</div>
				</el-carousel-item>
			</el-carousel>

        </div>


        <v-footer></v-footer>
    </div>
</template>

<script>
    import route from '../../components/common/route1'
    export default {
        name: "cjqh",
        data(){
            return{
                swiperOption: {
                    loop: true,
                    effect: "coverflow",
                    pagination: {
                        el: '.swiper-pagination', //分页器
                        clickable:true
                    },
                    initialSlide:1,
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 3,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    coverflowEffect: {
                        slideShadows: false // 滑块遮罩层
                    },
                },
                code:null,
                columnId:null,
                rootColumnId:null,
                dataList:null,
                value2:null,
                value3:null,
                bindData:[
                    {
                        name:'田园风光',
                        url:'#/tyfg?ljcode=tyfg&columnId=40288a9d6e91c70a016e91cecf5a0012&rootColumnId=40288a9d6e91c70a016e91c947000003',
                        cid:'40288a9d6e91c70a016e91cecf5a0012'
                    },
                    {
                        name:'赏花观鸟',
                        url:'#/shgn?ljcode=shgn&columnId=40288a9d6e91c70a016e91cefea00013&rootColumnId=40288a9d6e91c70a016e91c947000003',
                        cid:'40288a9d6e91c70a016e91cefea00013'
                    },
                    {
                        name:'美丽乡村',
                        url:'#/mlxc?ljcode=mlxc&columnId=40288a9d6e91c70a016e91cf30720014&rootColumnId=40288a9d6e91c70a016e91c947000003',
                        cid:'40288a9d6e91c70a016e91cf30720014'
                    }
                ],
            }
        },
        created() {
            this.code = this.$route.query.ljcode;
            this.columnId = this.$route.query.columnId;
            this.rootColumnId = this.$route.query.rootColumnId;
            this.url = [this.code,this.rootColumnId,this.columnId];
            this.getList();
        },
        methods:{
            getList(){
                let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=10&currentPage=1`;
                this.common.axios.get(url).then(v=>{
                    let data = v.data.data.list;
                    console.log(data);
                    data.forEach(v=>{
                        v.coverImageUrl = apiimg+v.coverImageUrl;
                        if(this.code=='cjqh'){
                            v.path=`/720?href=${v.href}&title=${v.title}`
                        }else{
                            v.path = `/detail2?ljcode=${this.code}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
                        }

                    });
                    this.dataList = data;
                })
            },
            toDetail(v){
                console.log(v);
                this.$router.push({path:`${v}`})
            }
        },
        components:{
            "v-route":route
        }
    }
</script>

<style lang="less" scoped>
    .nav{
        height: 350px;
        background: url("../../assets/img/ljlj/lake.png");
    }
    .el-carousel__item--card.is-active {
        z-index: 2;
        width: 850px;
        transform: translateX(200px) scale(1) !important;
    }

    .elimg{
        width: 850px;
        height: 500px ;
    }
    .title{
      //  color: black;

        letter-spacing: 5px;
        margin-top: 10px;
        font-size: 26px;
    }
    .container_box{



    }
    .move{
        transition: all 0.3s;
    }
.move:hover{
     transform: scale(1.1);
}

.carousel {
	height: 600px;
	&-item {		
		width: 100%;
		height: 600px;

		&-i {
			position: relative;
			width: 100%;
			height: 600px;
            cursor: pointer;
			&-title {
				position: absolute;
				height: 50px;
				text-align: center;
				background: rgba(0, 0, 0, 0.3);
				top: 0px;
				left: 0px;
				right: 0px;
				line-height: 50px;
				font-size: 40px;
				color: #fff;
			}
		}
	}
}

</style>
